<template>
  <div class="brdgFr" >
    <div class="jdDQPU" @click.prevent="viewProduct">
      <div class="ckFqou">
        <span class="hRjJTi"></span>
        <!-- 收藏按钮 - 根据状态显示不同图标 -->
        <section class="hfBdmA NinWN" @click.stop.prevent="handleFavorite" :title="isFavorited ? 'Remove from favorites' : 'Add to favorites'">
          <!-- 未收藏图标 - 空心 -->
          <svg v-if="!isFavorited" class="kOIKqN yEigr" xmlns="http://www.w3.org/2000/svg" viewBox="18 18 60 60" width="24px" height="24px">
            <g>
              <path
                d="M48,71.6c-0.5,0-1-0.2-1.4-0.6L27.5,52.5c-0.2-0.2-0.5-0.4-0.8-0.8c-0.4-0.4-0.9-1-1.7-2   c-0.8-1-1.5-2-2.1-3c-0.6-1-1.2-2.3-1.6-3.7c-0.5-1.5-0.7-2.9-0.7-4.2c0-4.5,1.3-8,3.9-10.6s6.2-3.8,10.8-3.8   c1.3,0,2.6,0.2,3.9,0.7c1.3,0.4,2.5,1,3.7,1.8c1.1,0.7,2.1,1.4,2.9,2.1c0.8,0.7,1.6,1.4,2.3,2.1c0.7-0.7,1.5-1.4,2.3-2.1   c0.8-0.7,1.8-1.4,2.9-2.1c1.1-0.7,2.4-1.3,3.7-1.8c1.3-0.4,2.6-0.7,3.9-0.7c4.6,0,8.2,1.3,10.8,3.8s3.9,6.1,3.9,10.6   c0,4.5-2.3,9.1-7,13.8L49.4,71C49,71.4,48.5,71.6,48,71.6z">
              </path>
            </g>
          </svg>
          <!-- 已收藏图标 - 实心 -->
          <svg v-else class="kOIKqN yEigr2" xmlns="http://www.w3.org/2000/svg" viewBox="18 18 60 60" width="24px" height="24px">
            <g>
              <path
                d="M48,71.6c-0.5,0-1-0.2-1.4-0.6L27.5,52.5c-0.2-0.2-0.5-0.4-0.8-0.8c-0.4-0.4-0.9-1-1.7-2   c-0.8-1-1.5-2-2.1-3c-0.6-1-1.2-2.3-1.6-3.7c-0.5-1.5-0.7-2.9-0.7-4.2c0-4.5,1.3-8,3.9-10.6s6.2-3.8,10.8-3.8   c1.3,0,2.6,0.2,3.9,0.7c1.3,0.4,2.5,1,3.7,1.8c1.1,0.7,2.1,1.4,2.9,2.1c0.8,0.7,1.6,1.4,2.3,2.1c0.7-0.7,1.5-1.4,2.3-2.1   c0.8-0.7,1.8-1.4,2.9-2.1c1.1-0.7,2.4-1.3,3.7-1.8c1.3-0.4,2.6-0.7,3.9-0.7c4.6,0,8.2,1.3,10.8,3.8s3.9,6.1,3.9,10.6   c0,4.5-2.3,9.1-7,13.8L49.4,71C49,71.4,48.5,71.6,48,71.6z">
              </path>
            </g>
          </svg>
        </section>
      </div>
      <a class="hVuiL" href="javascript:void(0)">
        <div class="bIDLrN">
          <img class="ccbPwe" :alt="product.title" :src="product.image" @error="handleImageError" />
        </div>
        <section class="krDmCz">
          <div class="kiJwvD row"></div>
          <div class="kiJwvD row">
            <div class="feovUU col-xs-12">
              <span class="title alZOz">{{ product.title }}</span>
            </div>
          </div>
          <div class="kiJwvD row">
            <div style="display: flex; flex-direction: column;width: 100%;">
              <div class="feovUU">
                <div>
                  <span class="kESQKC">
                    <span class="price">${{ product.currentPrice.toFixed(2) }}</span>
                  </span>
                  <span class="jPijkz">${{ product.originalPrice.toFixed(2) }}</span>
                </div>
              </div>
              <div class="feovUU">
                <section class="sc-kgoBCf cTjZbH"><i name="star" class="fa fa-star "
                    style="color: rgb(0, 0, 0); font-size: 11px; margin-right: 0px;"></i><i name="star"
                    class="fa fa-star " style="color: rgb(0, 0, 0); font-size: 11px; margin-right: 0px;"></i><i
                    name="star" class="fa fa-star "
                    style="color: rgb(0, 0, 0); font-size: 11px; margin-right: 0px;"></i><i name="star"
                    class="fa fa-star " style="color: rgb(0, 0, 0); font-size: 11px; margin-right: 0px;"></i><i
                    name="star-o" class="fa fa-star-o "
                    style="color: rgb(0, 0, 0); font-size: 11px; margin-right: 0px;"></i></section>
                <section v-if="product.isPrime" class="lbhUOd">
                  <svg class="cSPCYd" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                    <g transform="translate(-1577.9 -248.353)">
                      <g>
                        <rect height="24" rx="11.729" transform="translate(1577.9 248.353)" width="24"></rect>
                      </g>
                      <g>
                        <path
                          d="M1587.662,264.374l-3.08-3.2a.59.59,0,0,1,.85-.818l2.255,2.344,6.688-6.533a.589.589,0,1,1,.824.843Z"
                          fill="#f2f2f2"></path>
                      </g>
                    </g>
                  </svg>
                  <span> prime</span>
                </section>
              </div>
            </div>
          </div>
          <div class="kPWsBt">
            <div class="fLIRzu">{{ product.discount }}% off</div>
            <div class="fLIRzu">{{ product.daysLeft }} left</div>
            <div class="fLIRzu">{{ product.stock }} in stock</div>
          </div>
        </section>
      </a>
    </div>
  </div>
</template>

<script>
import userStore from '@/store/user.js'

export default {
  name: 'ProductCard',
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      userStore: userStore.state,
      isProcessing: false // 防止重复点击
    }
  },
  computed: {
    isLoggedIn() {
      return this.userStore.isLoggedIn
    },
    isFavorited() {
      // 优先使用产品自带的 isCollect 字段（注意是 isCollect 不是 iscollect）
      if (this.product.isCollect !== undefined) {
        return this.product.isCollect === true || this.product.isCollect === 1
      }
      // 如果产品有 iscollect 字段（API 原始数据）
      if (this.product.iscollect !== undefined) {
        return this.product.iscollect === 1
      }
      // 最后从 store 中获取
      return userStore.isFavorited(this.product.id)
    }
  },
  mounted() {
    window.scrollTo(0, 0)
    console.log(this.product);
    
  },
  methods: {
    async handleFavorite() {
      // 如果未登录，显示登录弹窗
      if (!this.isLoggedIn) {
        this.$root.$emit('show-favorite-modal')
        return
      }

      // 防止重复点击
      if (this.isProcessing) {
        return
      }

      this.isProcessing = true

      try {
        // 调用接口切换收藏状态
        await userStore.toggleFavorite(this.product.id)
        
        // 更新产品的收藏字段
        if (this.product.isCollect !== undefined) {
          this.product.isCollect = !this.product.isCollect
        }
        if (this.product.iscollect !== undefined) {
          this.product.iscollect = this.product.iscollect === 1 ? 0 : 1
        }
        
        // 强制更新视图
        this.$forceUpdate()
      } catch (err) {
        console.error('收藏操作失败:', err)
        this.$toast(err.message || 'Operation failed, please try again', 3000)
      } finally {
        this.isProcessing = false
      }
    },
    
    viewProduct() {
      // 导航到产品详情页
      this.$router.push(`/productDetail/${this.product.id || 1}`)
    },
    
    handleImageError(e) {
      e.target.src = 'https://via.placeholder.com/280x250?text=Product+Image'
    }
  }
}
</script>


<style scoped>
/* 收藏按钮样式 */
.hfBdmA.NinWN {
  cursor: pointer;
  transition: transform 0.2s ease;
  position: relative;
  z-index: 10;
}

.hfBdmA.NinWN:hover {
  transform: scale(1.15);
}

.hfBdmA.NinWN:active {
  transform: scale(0.95);
}

/* 未收藏图标 - 空心黑色 */
.kOIKqN.yEigr {
  fill: none;
  stroke: #000;
  stroke-width: 2;
  transition: all 0.3s ease;
}

.hfBdmA.NinWN:hover .kOIKqN.yEigr {
  fill: rgba(0, 0, 0, 0.2);
  stroke: #000;
}

/* 已收藏图标 - 实心红色 */
.kOIKqN.yEigr2 {
  fill: #000;
  stroke: #000;
  stroke-width: 1;
  transition: all 0.3s ease;
  animation: heartBeat 0.3s ease-in-out;
}

.hfBdmA.NinWN:hover .kOIKqN.yEigr2 {
  fill: #000;
  stroke: #000;
}
/* 收藏动画效果 */
@keyframes heartBeat {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(1.3);
  }
  50% {
    transform: scale(1.1);
  }
  75% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
</style>
